<template>
   <!--进度条样式-->
  <svg-progress-bar v-show="progressShow" :options="options" :type="type" :value="percent"></svg-progress-bar>
</template>

<script>
import svgProgressBar from 'svg-progress-bar'
export default {
  components: {
    svgProgressBar
  },
  data () {
    return {
      options: {
        radius: 35,
        maxValue: 100,
        circleWidth: 5,
        rectWidth: this.rectWidth,
        rectRadius: 5,
        rectHeight: this.rectHeight,
        textColor: this.textColor,
        pathColors: this.pathColors,
        duration: this.duration
      }
    }
  },
  props: {
    percent: {
      type: Number,
      default: 0
    },
    progressShow: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'circle'
    },
    pathColors: {
      type: Array
    },
    textColor: {
      type: String
    },
    rectHeight: {
      type: Number
    },
    rectWidth: {
      type: Number
    }
  }
}
</script>

<style scoped lang="scss">

</style>
